import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ApiActions from 'go/actions/api';
import {
  API_GRANT_BY_NUMBER_GET_SUCCESS,
  API_ORG_GET_BY_DUNS_SUCCESS,
  API_ORG_GET_BY_UEIEFT_SUCCESS,
  API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS,
  DYNAMIC_DATA_GET_ENTITY_SUCCESS,
} from 'common/types';
import {
  ENTITY_PAGE_TYPE_GRANT,
  ENTITY_PAGE_TYPE_SUBGRANT,
} from 'app-ui-componentlibrary/dist/common/constants';
import {Dropdown, Input, Button, Icon} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {isFemaUser} from 'common/utils';
import _ from 'lodash';
import {hasGeneralPermission} from 'go/security/permissions';
import {EXCLUDEDFOS} from 'common/requestDetails/constants.js';

const searchOptionsAll = [
  {
    key: 'grantId',
    text: 'Grant/Subgrant ID',
    value: 'grantId',
    title: 'Grant Identifier',
  },
];

// just search params for FEMA users
const searchOptionsFEMA = [
  {
    key: 'duns',
    text: 'DUNS',
    value: 'duns',
    title: 'DUNS',
  },
  {
    key: 'orgName',
    text: 'Organization Name',
    value: 'orgName',
    title: 'Organization Name',
  },
];

// just search params for FEMA users with UEI Toggle On
const searchOptionsUeiToggleFEMA = [
  {
    key: 'orgName',
    text: 'Organization Name',
    value: 'orgName',
    title: 'Organization Name',
  },
  {
    key: 'ueieft',
    text: 'UEI-EFT',
    value: 'ueieft',
    title: 'UEI-EFT',
  },
  {
    key: 'duns',
    text: 'DUNS',
    value: 'duns',
    title: 'DUNS',
  },
];

export class SearchBar extends Component {
  constructor(props) {
    super(props);

    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');

    if (props.hasFemaPermissions && dunsToUEIToggle) {
      this.searchOptions = _.concat(searchOptionsAll, searchOptionsUeiToggleFEMA);
    } else if (props.hasFemaPermissions && !dunsToUEIToggle) {
      this.searchOptions = _.concat(searchOptionsAll, searchOptionsFEMA);
    } else {
      this.searchOptions = searchOptionsAll;
    }

    this.state = {
      searching: false,
      results: null,
      searchBy: this.searchOptions[0],
      searchValue: '',
      options: this.searchOptions,
    };
  }

  changeSearchInput = (e, res) => {
    this.setState({
      searchValue: res.value,
      results: null,
    });
  };

  changeSearchType = (e, res) => {
    let searchBy = _.find(this.state.options, (option) => {
      return option.value === res.value;
    });
    this.setState({searchBy});
  };

  search = (searchApi, handleSuccess) => {
    const {token} = this.props;
    const {searchValue} = this.state;
    const externalSSPShield = _.includes(this.props.toggles, 'externalSSPShield');

    return searchApi(token, searchValue)
      .then((res) => {
        let foId = res.payload.fundingOpportunityId;
        if (
          !(res && res.hasResults) ||
          (externalSSPShield &&
            !this.props.hasFemaPermissions &&
            _.includes(EXCLUDEDFOS, Number(foId)))
        ) {
          return Promise.reject();
        }
        this.setState({
          searchValue: '',
          searching: false,
        });
        return handleSuccess(res.payload);
      })
      .catch((err) => {
        this.setState({
          results: [],
          searching: false,
        });
      });
  };

  onSearch = (e) => {
    e.preventDefault();

    const {
      getOrganizationByDuns,
      getOrganizationByUeiEft,
      navigateToOrgPage,
      getGrantByGrantNumber,
      getDynamicDataByEntityId,
      navigateToGrantLandingPage,
      navigateToSubGrantLandingPage,
      getOrganizationByDbaOrLegalName,
      navigateToSearchResults,
    } = this.props;

    const {searchBy, searchValue} = this.state;

    if (!_.isEmpty(searchValue)) {
      this.setState({
        searching: true,
      });
      switch (searchBy.value) {
        case 'grantId':
          this.search(getDynamicDataByEntityId, (payload) => {
            const entityType = _.get(payload, 'entityType');
            if (entityType === ENTITY_PAGE_TYPE_GRANT) {
              navigateToGrantLandingPage(payload.grantId);
            } else if (entityType === ENTITY_PAGE_TYPE_SUBGRANT) {
              navigateToSubGrantLandingPage(payload.entityId);
            }
          });
          break;
        case 'duns':
          this.search(getOrganizationByDuns, (payload) =>
            navigateToOrgPage(payload[0].organizationId)
          );
          break;
        case 'orgName':
          this.search(getOrganizationByDbaOrLegalName, () =>
            navigateToSearchResults(searchValue)
          );
          break;
        case 'ueieft':
          this.search(getOrganizationByUeiEft, (payload) =>
            navigateToOrgPage(payload[0].organizationId)
          );
          break;

        default:
          // no type to search by
          this.setState({
            searching: false,
          });
          break;
      }
    }
  };

  renderResult(result, link) {
    // stub for future autocompleting type stuff
    if (link) {
      return (
        <Link to={link}>
          <div className={`search-result interactive`}>{result}</div>
        </Link>
      );
    } else {
      return <div className={`search-result`}>{result}</div>;
    }
  }

  render() {
    const {options, results, searchBy, searchValue, searching} = this.state;
    const emptyMessage = '0 results found';
    const unauthSpecificProps = !this.props.hasFemaPermissions
      ? {
          className: 'single-item-dropdown',
          disabled: true,
          icon: null,
        }
      : {};

    const teamManagementExpansion = _.includes(
      this.props.toggles,
      'teamManagementExpansion'
    );

    if (
      teamManagementExpansion &&
      this.props.hasFemaPermissions &&
      !hasGeneralPermission('VIEW_GRANT')
    )
      return <></>;

    return (
      <div className="search-bar" onBlur={() => this.setState({results: null})}>
        <form onSubmit={this.onSearch}>
          <Input>
            <Input
              label={
                <Dropdown
                  value={searchBy.value}
                  options={options}
                  onChange={this.changeSearchType}
                  {...unauthSpecificProps}
                />
              }
              aria-label={`Search by ${searchBy.text}`}
              title={`Search by ${searchBy.text}`}
              labelPosition="left"
              value={searchValue}
              onChange={this.changeSearchInput}
            />
            <Button
              loading={searching}
              primary
              icon
              aria-label="Search Button"
              title="Search button"
            >
              <Icon name="search" fitted />
            </Button>
          </Input>

          {results !== null && (
            <div className="search-results-list">
              {results.length > 0
                ? _.map(results, (result) => this.renderResult(result, false)) // put link in place of false when using autocomplete
                : this.renderResult(emptyMessage, false)}
            </div>
          )}
        </form>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    toggles: state.toggles.toggles,
    hasFemaPermissions: isFemaUser(state.auth.permissions),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getGrantByGrantNumber: (token, number) => {
    const action = ApiActions.grant.getGrantByGrantNumber(token, number);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_GRANT_BY_NUMBER_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getOrganizationByDuns: (token, duns) => {
    const action = ApiActions.organization.getOrganizationByDUNS(token, duns);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_GET_BY_DUNS_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getOrganizationByUeiEft: (token, ueiEft) => {
    const action = ApiActions.organization.getOrganizationByUEIEFT(token, ueiEft);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_GET_BY_UEIEFT_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getOrganizationByDbaOrLegalName: (token, keywords) => {
    const action = ApiActions.organization.getOrganizationByDbaOrLegalName(
      token,
      keywords,
      1
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS &&
        res.payload.totalRecords > 0;
      return res;
    });
  },

  getDynamicDataByEntityId: (token, number) => {
    const action = ApiActions.dynamicData.getDataByEntityId(token, _.trim(number));
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === DYNAMIC_DATA_GET_ENTITY_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  navigateToGrantLandingPage: (number) => {
    dispatch(push(`/grant/${number}`));
  },
  navigateToOrgPage: (orgId) => {
    dispatch(push(`/organizationProfile/${orgId}`));
  },
  navigateToSearchResults: (orgName) => {
    dispatch(push(`/search/orgName/${orgName}`));
  },
  navigateToSubGrantLandingPage: (number) => {
    dispatch(push(`/subGrant/${number}`));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
